import { FC } from 'react';
import UserManagementHandler from '../Components/UserManagement/UserManagementHandler';

export const PageAdminSettings: FC = () => {
    return <UserManagementHandler />;
};
